import { configureStore } from './store';

const store = configureStore();
export { store };
export type { Toast } from './toastSchema';
export { toastSchema } from './toastSchema';
